import putV1StockAutoOrderPause from '@services/api/stock/order/auto/pause';
import { useMutation } from '@tanstack/react-query';

/**
 * @param {number} id
 */
function usePauseAutoOrder(id) {
  const { cb, key } = putV1StockAutoOrderPause(id);
  const { mutateAsync } = useMutation({
    mutationKey: key,
    mutationFn: cb,
  });

  return mutateAsync;
}

export default usePauseAutoOrder;
